import React, { useEffect, useState } from "react";
import { message as toast } from "antd";

const SelectSubscription = ({
  onClick,
  handleCancel,
  subscriptionPlane,
  activeSubscription,
}) => {

  const [planTypeSubscription, setPlanTypeSubscription] = useState([]);
  useEffect(() => {
    let data = [];
    subscriptionPlane?.map((item) => (
      item?.billingCycle == "Monthly" && data.push(item)
    ));
    setPlanTypeSubscription(data);
  }, []);

  const handleClickYearlyMonthly = (val) => {
    if (val == "Monthly") {
      let data = [];
      subscriptionPlane?.map((item) => (
        item?.billingCycle == "Monthly" && data.push(item)
      ));
      setPlanTypeSubscription(data);
    } else if (val == "Yearly") {
      let data = [];
      subscriptionPlane?.map((item) => (
        item?.billingCycle == "Yearly" && data.push(item)
      ));
      setPlanTypeSubscription(data);
    };
  };

  const handleSubmit = (val) => {
    onClick(val);
  };

  return (
    <>
      <div
        className={`modal show d-block ${activeSubscription?.trial_end_date ? "ct_short_modal" : ""} ct_congratulation_modal_fade modal-lg`}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "700px" }}>
          <div className="modal-content ct_pricing_modal border-0">
            <div className="modal-body pt-4 text-center et_px_100 pb-4 position-relative">
              <i className="fa fa-close close_btn" onClick={handleCancel}></i>
              <nav className="pricing_toogle">
                <div className="nav nav-tabs border-0" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active border-0"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                    onClick={() => handleClickYearlyMonthly('Monthly')}
                  >
                    Monthly
                  </button>
                  <button
                    className="nav-link border-0"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                    onClick={() => handleClickYearlyMonthly('Yearly')}
                  >
                    Yearly
                  </button>
                </div>
              </nav>
              <div className="tab-content mt-5" id="pills-tabContent">
                <div
                  className="tab-pane fade show active text-start"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className={planTypeSubscription?.length != 0 ? "et_grid_2_50" : ""}>
                    {planTypeSubscription?.length != 0 ?
                      planTypeSubscription?.map((item) => (
                        <div className="et_subs_bg_card" key={item?.id}>
                          <div className="et_logo my-4">
                            <img src="img/Logo_blue_new.png" />
                          </div>
                          <h4 className="mb-1 et_fs_22" style={{ maxWidth: '15rem' }}>{item?.name ?? ''}</h4>
                          <p
                            className="mb-0"
                            style={{ color: "#aaa", fontWeight: "400", maxWidth: '15rem', minHeight: '58px' }}
                          >
                            {item?.name ?? ''} 1 Month subscription to First Mate ServiceHub
                          </p>
                          <h2 className="et_fs_28 mb-4">
                            A$ {item?.price ?? 0} <span className="et_small_text"> per month</span>
                          </h2>
                          <button className="et_blue_full_btn" onClick={() => handleSubmit(item)}>{activeSubscription ? "Upgrade Plan" : "Start Trial"}</button>
                        </div>
                      ))
                      :
                      <>
                        <h6 className='text-center mb-2 ct_fw_500' style={{ fontSize: "18px" }} >
                          {activeSubscription?.planId === 4 ? (
                            "You are already subscribed to the highest available plan."
                          ) : activeSubscription?.trial_end_date ? (
                            "You can upgrade the plan after your trial subscription ends."
                          ) : (
                            "To downgrade your plan, please cancel your current subscription and subscribe to a new plan once your current cycle ends, or contact support."
                          )}
                          {!activeSubscription?.trial_end_date && (
                            <>
                              <br />
                              <span className="ct_clr_blue_dark">ahoy@firstmate.com.au</span>
                            </>
                          )}
                        </h6>
                        <div className='modal-footer justify-content-center border-0'>
                          <button
                            type="button"
                            className="ct_orange_btn ct_modal_submit"
                            onClick={handleCancel}
                          >
                            OK
                          </button>
                        </div>
                      </>
                    }
                  </div>
                </div>
                <div
                  className="tab-pane fade text-start"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <div className={planTypeSubscription?.length != 0 ? "et_grid_2_50" : ""}>
                    {planTypeSubscription?.length != 0 ?
                      planTypeSubscription?.map((item) => (
                        <div className="et_subs_bg_card" key={item?.id}>

                          <div className="et_logo my-4">
                            <img src="img/Logo_blue_new.png" />
                          </div>
                          <h4 className="mb-1 et_fs_22" style={{ maxWidth: '15rem' }}>{item?.name ?? ''}</h4>
                          <p
                            className="mb-0"
                            style={{ color: "#aaa", fontWeight: "400", maxWidth: '15rem', minHeight: '58px' }}
                          >
                            {item?.name ?? ''} 12 Month subscription to First Mate ServiceHub
                          </p>
                          <h2 className="et_fs_28 mb-4">
                            A$ {item?.price ?? 0} <span className="et_small_text"> per year</span>
                          </h2>
                          <button className="et_blue_full_btn" onClick={() => handleSubmit(item)}>{activeSubscription ? "Upgrade Plan" : "Start Trial"}</button>
                        </div>
                      ))
                      :
                      <>
                        <h6 className='text-center mb-2 ct_fw_500' style={{ fontSize: "18px" }} >
                          {activeSubscription?.planId === 4 ? (
                            "You are already subscribed to the highest available plan."
                          ) : activeSubscription?.trial_end_date ? (
                            "You can upgrade the plan after your trial subscription ends."
                          ) : (
                            "To downgrade your plan, please cancel your current subscription and subscribe to a new plan once your current cycle ends, or contact support."
                          )}
                          {!activeSubscription?.trial_end_date && (
                            <>
                              <br />
                              <span className="ct_clr_blue_dark">ahoy@firstmate.com.au</span>
                            </>
                          )}
                        </h6>
                        <div className='modal-footer justify-content-center border-0'>
                          <button
                            type="button"
                            className="ct_orange_btn ct_modal_submit"
                            onClick={handleCancel}
                          >
                            OK
                          </button>
                        </div>
                      </>
                    }
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div >




      <>
        {/* Pricing Modal */}
        {/* <div className="modal show d-block fade ct_congratulation_modal_fade"  tabIndex={-1}>
    <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div className="modal-content ct_pricing_modal">
        <div className="modal-body p-4">
       
          <div className="d-flex justify-content-end align-items-center mb-4 ">
            <i
              className="fa-solid fa-xmark ct_pointer"
              data-bs-dismiss="modal"
            />
          </div>
          <nav className="pricing_toogle">
            <div className="nav nav-tabs border-0" id="nav-tab" role="tablist">
              <button
                className="nav-link active border-0"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                   onClick={() => handleClickYearlyMonthly('Monthly')}
              >
                Monthly
              </button>
              <button
                className="nav-link border-0"
                id="nav-profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                 onClick={() => handleClickYearlyMonthly('Yearly')}
              >
                Yearly
              </button>
            </div>
          </nav>
          <div className="tab-content " id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="ct_price_card_custom  position-relative">
                
                    <div className="d-flex justify-content-between align-items-center">
                    
                      <div className="ct_icon_box ">
                        <svg
                          width={16}
                          height={15}
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 3.33333V1.66667C8 0.75 7.28 0 6.4 0H1.6C0.72 0 0 0.75 0 1.66667V13.3333C0 14.25 0.72 15 1.6 15H14.4C15.28 15 16 14.25 16 13.3333V5C16 4.08333 15.28 3.33333 14.4 3.33333H8ZM3.2 13.3333H1.6V11.6667H3.2V13.3333ZM3.2 10H1.6V8.33333H3.2V10ZM3.2 6.66667H1.6V5H3.2V6.66667ZM3.2 3.33333H1.6V1.66667H3.2V3.33333ZM6.4 13.3333H4.8V11.6667H6.4V13.3333ZM6.4 10H4.8V8.33333H6.4V10ZM6.4 6.66667H4.8V5H6.4V6.66667ZM6.4 3.33333H4.8V1.66667H6.4V3.33333ZM13.6 13.3333H8V11.6667H9.6V10H8V8.33333H9.6V6.66667H8V5H13.6C14.04 5 14.4 5.375 14.4 5.83333V12.5C14.4 12.9583 14.04 13.3333 13.6 13.3333ZM12.8 6.66667H11.2V8.33333H12.8V6.66667ZM12.8 10H11.2V11.6667H12.8V10Z"
                            fill="#013760"
                          />
                        </svg>
                      </div>
                      <span className="cti_stndrd_badge">STANDARD</span>
                    </div>
                  
                    <h5 className="mb-1 ct_fw_400 ct_fs_16 mt-4 ct_text_dark">
                      Sole Trader
                    </h5>
                    <p className="ct_fs_16 ct_fw_400 ct_text_dark mb-3">
                      1 Field Accounts
                    </p>
                  
                    <h4 className="ct_price ct_fs_16 ct_fw_400 mb-5 ct_blue_text">
                      A$ 198{" "}
                      <span className="ct_text_dark ct_fs_14 ct_fw_400">
                        / month
                      </span>
                    </h4>
                 
                    <div className="ct_feature d-flex align-items-center gap-3 mb-4">
                      <svg
                        className="flex-shrink-0"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.45 10.95L11.7375 5.6625L10.6875 4.6125L6.45 8.85L4.3125 6.7125L3.2625 7.7625L6.45 10.95ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4812 2.19375 12.8062C1.51875 12.1312 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1312 1.51875 12.8062 2.19375C13.4812 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4812 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.175 13.5 10.5938 12.9188 11.7563 11.7563C12.9188 10.5938 13.5 9.175 13.5 7.5C13.5 5.825 12.9188 4.40625 11.7563 3.24375C10.5938 2.08125 9.175 1.5 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 9.175 2.08125 10.5938 3.24375 11.7563C4.40625 12.9188 5.825 13.5 7.5 13.5Z"
                          fill="#23C0E8"
                        />
                      </svg>
                      <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                        Sole Trader 1 Field Account 1 Month subscription to
                        First Mate ServiceHub
                      </p>
                    </div>
                 
                    <a
                      href="pricing-subscription.html"
                      className="ct_orange_btn w-100"
                    >
                      Start Trial
                      <svg
                        className="ms-2"
                        width={12}
                        height={12}
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.13125 6.75H0V5.25H9.13125L4.93125 1.05L6 0L12 6L6 12L4.93125 10.95L9.13125 6.75Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="ct_price_card_custom active position-relative overflow-hidden">
                 
                    <span className="ct_popular_tag">POPULAR</span>
                   
                    <div className="ct_icon_box mb-4">
                      <svg
                        width={16}
                        height={15}
                        viewBox="0 0 16 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 3.33333V1.66667C8 0.75 7.28 0 6.4 0H1.6C0.72 0 0 0.75 0 1.66667V13.3333C0 14.25 0.72 15 1.6 15H14.4C15.28 15 16 14.25 16 13.3333V5C16 4.08333 15.28 3.33333 14.4 3.33333H8ZM3.2 13.3333H1.6V11.6667H3.2V13.3333ZM3.2 10H1.6V8.33333H3.2V10ZM3.2 6.66667H1.6V5H3.2V6.66667ZM3.2 3.33333H1.6V1.66667H3.2V3.33333ZM6.4 13.3333H4.8V11.6667H6.4V13.3333ZM6.4 10H4.8V8.33333H6.4V10ZM6.4 6.66667H4.8V5H6.4V6.66667ZM6.4 3.33333H4.8V1.66667H6.4V3.33333ZM13.6 13.3333H8V11.6667H9.6V10H8V8.33333H9.6V6.66667H8V5H13.6C14.04 5 14.4 5.375 14.4 5.83333V12.5C14.4 12.9583 14.04 13.3333 13.6 13.3333ZM12.8 6.66667H11.2V8.33333H12.8V6.66667ZM12.8 10H11.2V11.6667H12.8V10Z"
                          fill="#013760"
                        />
                      </svg>
                    </div>
                
                    <h5 className="mb-1 ct_fw_400 ct_fs_16 mt-4 ct_text_dark">
                      Small Business
                    </h5>
                    <p className="ct_fs_16 ct_fw_400 ct_text_dark mb-3">
                      2-5 Field Accounts
                    </p>
                 
                    <h4 className="ct_price ct_fs_16 ct_fw_400 mb-5 ct_blue_text">
                      A$ 498{" "}
                      <span className="ct_text_dark ct_fs_14 ct_fw_400">
                        / month
                      </span>
                    </h4>
             
                    <div className="ct_feature d-flex align-items-center gap-3 mb-4">
                      <svg
                        className="flex-shrink-0"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.45 10.95L11.7375 5.6625L10.6875 4.6125L6.45 8.85L4.3125 6.7125L3.2625 7.7625L6.45 10.95ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4812 2.19375 12.8062C1.51875 12.1312 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1312 1.51875 12.8062 2.19375C13.4812 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4812 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.175 13.5 10.5938 12.9188 11.7563 11.7563C12.9188 10.5938 13.5 9.175 13.5 7.5C13.5 5.825 12.9188 4.40625 11.7563 3.24375C10.5938 2.08125 9.175 1.5 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 9.175 2.08125 10.5938 3.24375 11.7563C4.40625 12.9188 5.825 13.5 7.5 13.5Z"
                          fill="#23C0E8"
                        />
                      </svg>
                      <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                        Small Business 2-5 Field Accounts 1 Month subscription
                        to First Mate ServiceHub
                      </p>
                    </div>
                 
                    <a
                      href="pricing-subscription.html"
                      className="ct_orange_btn w-100"
                    >
                      Start Trial
                      <svg
                        className="ms-2"
                        width={16}
                        height={16}
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.7 5.99667L4.1625 6.61542C4.3375 6.26542 4.51875 5.92792 4.70625 5.60292C4.89375 5.27792 5.1 4.95292 5.325 4.62792L4.275 4.42167L2.7 5.99667ZM5.3625 7.55292L7.5 9.67167C8.025 9.47167 8.5875 9.16542 9.1875 8.75292C9.7875 8.34042 10.35 7.87167 10.875 7.34667C11.75 6.47167 12.4344 5.4998 12.9281 4.43105C13.4219 3.3623 13.6375 2.37792 13.575 1.47792C12.675 1.41542 11.6875 1.63105 10.6125 2.1248C9.5375 2.61855 8.5625 3.30292 7.6875 4.17792C7.1625 4.70292 6.69375 5.26542 6.28125 5.86542C5.86875 6.46542 5.5625 7.02792 5.3625 7.55292ZM8.7 6.33417C8.4125 6.04667 8.26875 5.69355 8.26875 5.2748C8.26875 4.85605 8.4125 4.50292 8.7 4.21542C8.9875 3.92792 9.34375 3.78417 9.76875 3.78417C10.1938 3.78417 10.55 3.92792 10.8375 4.21542C11.125 4.50292 11.2688 4.85605 11.2688 5.2748C11.2688 5.69355 11.125 6.04667 10.8375 6.33417C10.55 6.62167 10.1938 6.76542 9.76875 6.76542C9.34375 6.76542 8.9875 6.62167 8.7 6.33417ZM9.05625 12.3529L10.6313 10.7779L10.425 9.72792C10.1 9.95292 9.775 10.156 9.45 10.3373C9.125 10.5185 8.7875 10.6967 8.4375 10.8717L9.05625 12.3529ZM14.925 0.109173C15.1625 1.62167 15.0156 3.09355 14.4844 4.5248C13.9531 5.95605 13.0375 7.32167 11.7375 8.62167L12.1125 10.4779C12.1625 10.7279 12.15 10.9717 12.075 11.2092C12 11.4467 11.875 11.6529 11.7 11.8279L8.55 14.9779L6.975 11.2842L3.76875 8.07792L0.075 6.50292L3.20625 3.35292C3.38125 3.17792 3.59062 3.05292 3.83437 2.97792C4.07812 2.90292 4.325 2.89042 4.575 2.94042L6.43125 3.31542C7.73125 2.01542 9.09375 1.09667 10.5188 0.559173C11.9438 0.0216734 13.4125 -0.128327 14.925 0.109173ZM1.40625 10.4592C1.84375 10.0217 2.37813 9.7998 3.00938 9.79355C3.64062 9.7873 4.175 10.0029 4.6125 10.4404C5.05 10.8779 5.26562 11.4123 5.25938 12.0435C5.25313 12.6748 5.03125 13.2092 4.59375 13.6467C4.28125 13.9592 3.75938 14.2279 3.02813 14.4529C2.29688 14.6779 1.2875 14.8779 0 15.0529C0.175 13.7654 0.375 12.756 0.6 12.0248C0.825 11.2935 1.09375 10.7717 1.40625 10.4592ZM2.475 11.5092C2.35 11.6342 2.225 11.8623 2.1 12.1935C1.975 12.5248 1.8875 12.8592 1.8375 13.1967C2.175 13.1467 2.50938 13.0623 2.84063 12.9435C3.17188 12.8248 3.4 12.7029 3.525 12.5779C3.675 12.4279 3.75625 12.2467 3.76875 12.0342C3.78125 11.8217 3.7125 11.6404 3.5625 11.4904C3.4125 11.3404 3.23125 11.2685 3.01875 11.2748C2.80625 11.281 2.625 11.3592 2.475 11.5092Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="ct_price_card_custom  position-relative">
                 
                    <div className="d-flex justify-content-between align-items-center">
                   
                      <div className="ct_icon_box ">
                        <svg
                          width={16}
                          height={15}
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 3.33333V1.66667C8 0.75 7.28 0 6.4 0H1.6C0.72 0 0 0.75 0 1.66667V13.3333C0 14.25 0.72 15 1.6 15H14.4C15.28 15 16 14.25 16 13.3333V5C16 4.08333 15.28 3.33333 14.4 3.33333H8ZM3.2 13.3333H1.6V11.6667H3.2V13.3333ZM3.2 10H1.6V8.33333H3.2V10ZM3.2 6.66667H1.6V5H3.2V6.66667ZM3.2 3.33333H1.6V1.66667H3.2V3.33333ZM6.4 13.3333H4.8V11.6667H6.4V13.3333ZM6.4 10H4.8V8.33333H6.4V10ZM6.4 6.66667H4.8V5H6.4V6.66667ZM6.4 3.33333H4.8V1.66667H6.4V3.33333ZM13.6 13.3333H8V11.6667H9.6V10H8V8.33333H9.6V6.66667H8V5H13.6C14.04 5 14.4 5.375 14.4 5.83333V12.5C14.4 12.9583 14.04 13.3333 13.6 13.3333ZM12.8 6.66667H11.2V8.33333H12.8V6.66667ZM12.8 10H11.2V11.6667H12.8V10Z"
                            fill="#013760"
                          />
                        </svg>
                      </div>
                      <span className="cti_stndrd_badge">STANDARD</span>
                    </div>
                 
                    <h5 className="mb-1 ct_fw_400 ct_fs_16 mt-4 ct_text_dark">
                      Sole Trader
                    </h5>
                    <p className="ct_fs_16 ct_fw_400 ct_text_dark mb-3">
                      1 Field Accounts
                    </p>
                  
                    <h4 className="ct_price ct_fs_16 ct_fw_400 mb-5 ct_blue_text">
                      A$ 1980{" "}
                      <span className="ct_text_dark ct_fs_14 ct_fw_400">
                        / year
                      </span>
                    </h4>
                   
                    <div className="ct_feature d-flex align-items-center gap-3 mb-4">
                      <svg
                        className="flex-shrink-0"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.45 10.95L11.7375 5.6625L10.6875 4.6125L6.45 8.85L4.3125 6.7125L3.2625 7.7625L6.45 10.95ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4812 2.19375 12.8062C1.51875 12.1312 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1312 1.51875 12.8062 2.19375C13.4812 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4812 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.175 13.5 10.5938 12.9188 11.7563 11.7563C12.9188 10.5938 13.5 9.175 13.5 7.5C13.5 5.825 12.9188 4.40625 11.7563 3.24375C10.5938 2.08125 9.175 1.5 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 9.175 2.08125 10.5938 3.24375 11.7563C4.40625 12.9188 5.825 13.5 7.5 13.5Z"
                          fill="#23C0E8"
                        />
                      </svg>
                      <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                        Sole Trader 1 Field Account 1 Month subscription to
                        First Mate ServiceHub
                      </p>
                    </div>
                 
                    <a
                      href="pricing-subscription.html"
                      className="ct_orange_btn w-100"
                    >
                      Start Trial
                      <svg
                        className="ms-2"
                        width={12}
                        height={12}
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.13125 6.75H0V5.25H9.13125L4.93125 1.05L6 0L12 6L6 12L4.93125 10.95L9.13125 6.75Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="ct_price_card_custom active position-relative overflow-hidden">
                 
                    <span className="ct_popular_tag">POPULAR</span>
                  
                    <div className="ct_icon_box mb-4">
                      <svg
                        width={16}
                        height={15}
                        viewBox="0 0 16 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 3.33333V1.66667C8 0.75 7.28 0 6.4 0H1.6C0.72 0 0 0.75 0 1.66667V13.3333C0 14.25 0.72 15 1.6 15H14.4C15.28 15 16 14.25 16 13.3333V5C16 4.08333 15.28 3.33333 14.4 3.33333H8ZM3.2 13.3333H1.6V11.6667H3.2V13.3333ZM3.2 10H1.6V8.33333H3.2V10ZM3.2 6.66667H1.6V5H3.2V6.66667ZM3.2 3.33333H1.6V1.66667H3.2V3.33333ZM6.4 13.3333H4.8V11.6667H6.4V13.3333ZM6.4 10H4.8V8.33333H6.4V10ZM6.4 6.66667H4.8V5H6.4V6.66667ZM6.4 3.33333H4.8V1.66667H6.4V3.33333ZM13.6 13.3333H8V11.6667H9.6V10H8V8.33333H9.6V6.66667H8V5H13.6C14.04 5 14.4 5.375 14.4 5.83333V12.5C14.4 12.9583 14.04 13.3333 13.6 13.3333ZM12.8 6.66667H11.2V8.33333H12.8V6.66667ZM12.8 10H11.2V11.6667H12.8V10Z"
                          fill="#013760"
                        />
                      </svg>
                    </div>
              
                    <h5 className="mb-1 ct_fw_400 ct_fs_16 mt-4 ct_text_dark">
                      Small Business
                    </h5>
                    <p className="ct_fs_16 ct_fw_400 ct_text_dark mb-3">
                      2-5 Field Accounts
                    </p>
                
                    <h4 className="ct_price ct_fs_16 ct_fw_400 mb-5 ct_blue_text">
                      A$ 4980{" "}
                      <span className="ct_text_dark ct_fs_14 ct_fw_400">
                        / year
                      </span>
                    </h4>
               
                    <div className="ct_feature d-flex align-items-center gap-3 mb-4">
                      <svg
                        className="flex-shrink-0"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.45 10.95L11.7375 5.6625L10.6875 4.6125L6.45 8.85L4.3125 6.7125L3.2625 7.7625L6.45 10.95ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4812 2.19375 12.8062C1.51875 12.1312 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1312 1.51875 12.8062 2.19375C13.4812 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4812 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.175 13.5 10.5938 12.9188 11.7563 11.7563C12.9188 10.5938 13.5 9.175 13.5 7.5C13.5 5.825 12.9188 4.40625 11.7563 3.24375C10.5938 2.08125 9.175 1.5 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 9.175 2.08125 10.5938 3.24375 11.7563C4.40625 12.9188 5.825 13.5 7.5 13.5Z"
                          fill="#23C0E8"
                        />
                      </svg>
                      <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                        Small Business 2-5 Field Accounts 1 Month subscription
                        to First Mate ServiceHub
                      </p>
                    </div>
               
                    <a
                      href="pricing-subscription.html"
                      className="ct_orange_btn w-100"
                    >
                      Start Trial
                      <svg
                        className="ms-2"
                        width={16}
                        height={16}
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.7 5.99667L4.1625 6.61542C4.3375 6.26542 4.51875 5.92792 4.70625 5.60292C4.89375 5.27792 5.1 4.95292 5.325 4.62792L4.275 4.42167L2.7 5.99667ZM5.3625 7.55292L7.5 9.67167C8.025 9.47167 8.5875 9.16542 9.1875 8.75292C9.7875 8.34042 10.35 7.87167 10.875 7.34667C11.75 6.47167 12.4344 5.4998 12.9281 4.43105C13.4219 3.3623 13.6375 2.37792 13.575 1.47792C12.675 1.41542 11.6875 1.63105 10.6125 2.1248C9.5375 2.61855 8.5625 3.30292 7.6875 4.17792C7.1625 4.70292 6.69375 5.26542 6.28125 5.86542C5.86875 6.46542 5.5625 7.02792 5.3625 7.55292ZM8.7 6.33417C8.4125 6.04667 8.26875 5.69355 8.26875 5.2748C8.26875 4.85605 8.4125 4.50292 8.7 4.21542C8.9875 3.92792 9.34375 3.78417 9.76875 3.78417C10.1938 3.78417 10.55 3.92792 10.8375 4.21542C11.125 4.50292 11.2688 4.85605 11.2688 5.2748C11.2688 5.69355 11.125 6.04667 10.8375 6.33417C10.55 6.62167 10.1938 6.76542 9.76875 6.76542C9.34375 6.76542 8.9875 6.62167 8.7 6.33417ZM9.05625 12.3529L10.6313 10.7779L10.425 9.72792C10.1 9.95292 9.775 10.156 9.45 10.3373C9.125 10.5185 8.7875 10.6967 8.4375 10.8717L9.05625 12.3529ZM14.925 0.109173C15.1625 1.62167 15.0156 3.09355 14.4844 4.5248C13.9531 5.95605 13.0375 7.32167 11.7375 8.62167L12.1125 10.4779C12.1625 10.7279 12.15 10.9717 12.075 11.2092C12 11.4467 11.875 11.6529 11.7 11.8279L8.55 14.9779L6.975 11.2842L3.76875 8.07792L0.075 6.50292L3.20625 3.35292C3.38125 3.17792 3.59062 3.05292 3.83437 2.97792C4.07812 2.90292 4.325 2.89042 4.575 2.94042L6.43125 3.31542C7.73125 2.01542 9.09375 1.09667 10.5188 0.559173C11.9438 0.0216734 13.4125 -0.128327 14.925 0.109173ZM1.40625 10.4592C1.84375 10.0217 2.37813 9.7998 3.00938 9.79355C3.64062 9.7873 4.175 10.0029 4.6125 10.4404C5.05 10.8779 5.26562 11.4123 5.25938 12.0435C5.25313 12.6748 5.03125 13.2092 4.59375 13.6467C4.28125 13.9592 3.75938 14.2279 3.02813 14.4529C2.29688 14.6779 1.2875 14.8779 0 15.0529C0.175 13.7654 0.375 12.756 0.6 12.0248C0.825 11.2935 1.09375 10.7717 1.40625 10.4592ZM2.475 11.5092C2.35 11.6342 2.225 11.8623 2.1 12.1935C1.975 12.5248 1.8875 12.8592 1.8375 13.1967C2.175 13.1467 2.50938 13.0623 2.84063 12.9435C3.17188 12.8248 3.4 12.7029 3.525 12.5779C3.675 12.4279 3.75625 12.2467 3.76875 12.0342C3.78125 11.8217 3.7125 11.6404 3.5625 11.4904C3.4125 11.3404 3.23125 11.2685 3.01875 11.2748C2.80625 11.281 2.625 11.3592 2.475 11.5092Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div className="ct_modal_divider mt-5" />
          <div className="ct_mt_25 text-center ct_text_dark ct_fs_14 ct-fw_400">
            Already have an account?
            <a href="login.html" className="ct_blue_text ct_fs_14 ct_fw_600">
              Log In
            </a>
          </div>
        </div>
      </div>
    </div>
  </div> */}
      </>

    </>






  );
};

export default SelectSubscription;
